<template>

    <div class="row mt-4">

        <div class="col-lg-6">

            <div class="example-price">

                <span>&pound;{{ sliderCostExVat }}<span class="per-month">Per Month</span><span class="ex-vat">ex. VAT</span></span>

            </div>

        </div>

        <div class="col-lg-6">

            <div class="total-premises">
                <label for="price-slider">{{ this.sliderQuantity }} Premises <i class="fad fa-building"></i></label>
            </div>

            <div>
                <input type="range" id="price-slider" v-model="sliderQuantity" class="custom-range" min="1" max="20">
            </div>

        </div>

    </div>

</template>

<script>

    export default {

        props: {
            currentquantity: 0,
            currentpremisescount: 0,
            perpremisescostpence: 0,
            vatPercentage: 20,
        },

        data() {

            return {
                sliderQuantity: 1,
            };
        },

        computed: {

            sliderCostExVat: function() {
                return (this.perpremisescostpence * this.sliderQuantity) / 100;
            },

            sliderCostIncVat: function() {
                return ((this.perpremisescostpence * this.sliderQuantity) / 100) + (((this.perpremisescostpence * this.sliderQuantity) / 100) * (this.vatPercentage / 100));
            },
        },

        mounted() {

            this.sliderQuantity = this.currentquantity;
        },

        methods: {

            updateQuantity() {

                console.log('Slider', this.sliderQuantity);
                console.log('Premises', this.currentpremisescount);
                console.log('Check', this.sliderQuantity < this.currentpremisescount);
            }
        }
    }

</script>
